<template>
  <v-container id="distanceCon" class="blue lighten-4 pa-0" fluid>
    <div id="mapWorkspace">
      <v-card
        id="mainPadWrap"
        class="ml-3 mt-3"
        flat
        tile
        :disabled="routeLayerVisible"
      >
        <v-card
          id="portEnterCon"
          tile
          class="d-flex justify-space-between align-bottom pl-4 pr-2 py-2"
          :disabled="turnLayerVisible"
        >
          <v-autocomplete
            v-model="select"
            class=""
            dense
            hide-details
            :placeholder="$t('m.enterPort')"
            :items="items"
            :loading="isLoading"
            :search-input.sync="search"
            hide-no-data
            item-text="FULLNAME"
            item-value="PORTID"
            return-object
          />
          <v-btn icon class="ml-3" @click="openMulti">
            <v-icon>mdi-web</v-icon>
          </v-btn>
        </v-card>
        <!-- end portEnterCon -->

        <v-card
          id="portPad"
          class="transparent mt-3"
          tile
          v-if="portPadVisible"
        >
          <v-card flat tile class="grey lighten-5">
            <v-toolbar class="grey lighten-4" flat dense align-center>
              <v-text-field
                :placeholder="$t('m.speed')"
                dense
                style="width: 12px"
                type="number"
                v-model="speed"
                :suffix="$t('m.knots')"
                hide-details
                value="12"
              />
              <v-badge
                color="primary"
                :value="wayPointBadgeVisible"
                dot
                overlap
              >
                <v-btn
                  class="ml-3"
                  icon
                  small
                  @click="changeWayPoint"
                  :disabled="turnLayerVisible"
                >
                  <v-icon>mdi-router</v-icon>
                </v-btn>
              </v-badge>
              <v-badge color="primary" :value="turnBadgeVisible" dot overlap>
                <v-btn
                  class="ml-2"
                  icon
                  small
                  @click="changeTurn"
                  :disabled="!isCompleteDistance || routeLayerVisible"
                >
                  <v-icon>mdi-navigation</v-icon>
                </v-btn>
              </v-badge>

              <v-spacer />
              <v-btn
                small
                depressed
                rounded
                color="primary"
                dark
                @click="getDistance"
                v-show="getBtnVisible"
              >
                {{ $t("m.getDistance") }}
              </v-btn>
              <!--
              <v-btn class="mr-1" color="brown lighten-1" icon small @click="clearOnlyDis"
                v-show="clearOnlyDisBtnVisible">
                <v-icon>mdi-delete</v-icon>
              </v-btn> -->

              <v-progress-linear
                :active="isCalculating"
                :indeterminate="isCalculating"
                absolute
                bottom
                color="deep-purple accent-4"
              />
            </v-toolbar>
            <v-divider />
            <v-card flat tile class="px-3">
              <!-- filter(ele => !ele.isWayPoint) -->
              <template v-for="(port, i) in portPointArr">
                <v-divider v-if="i !== 0" :key="`${i}-divider`" />
                <v-row no-gutters class="py-2" align="center">
                  <v-col cols="4" class="">
                    <template v-if="port.isCoordinate">
                      <span class="text-caption font-weight-bold">{{
                        port.PortName
                      }}</span>
                    </template>
                    <template v-else>
                      <template v-if="port.isWayPoint">
                        <span
                          class="font-italic text-caption font-weight-bold"
                          >{{ port.PortName }}</span
                        >
                      </template>
                      <template v-else>
                        {{ port.PortName }}
                      </template>
                    </template>
                  </v-col>
                  <template
                    v-if="
                      routePorts.length > 0 && i < routePorts.length && i > 0
                    "
                  >
                    <v-col cols="3" class="text-caption text-right">
                      {{ _.round(routePorts[i].gVal, 2) }} {{ $t("m.nm") }}
                    </v-col>
                    <v-col cols="3" class="text-caption text-right">
                      {{ _.round(routePorts[i].time, 2) }} {{ $t("m.days") }}
                    </v-col>
                  </template>
                  <template v-else>
                    <v-col cols="3" />
                    <v-col cols="3" />
                  </template>
                  <v-col cols="2" class="text-right">
                    <v-btn
                      icon
                      small
                      color="brown lighten-3"
                      @click="delPort(port, i)"
                      :disabled="turnLayerVisible"
                    >
                      <v-icon>mdi-minus</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </template>
            </v-card>
            <!-- end 港口列表 -->
            <v-divider />
          </v-card>
          <!-- end top details -->

          <v-card flat tile class="text-center py-3">
            <v-row no-gutters class="font-weight-bold text-caption">
              <v-col cols="4" class="transparent">
                <p class="mb-1 grey--text darken-4">
                  {{ $t("m.ttlDistance") }}
                </p>
                <p
                  class="mb-0 text-body-2 font-weight-bold grey--text text--darken-3"
                >
                  {{ ttlDistance }}
                  <span>{{ $t("m.nm") }}</span>
                </p>
              </v-col>
              <v-col cols="4" class="transparent">
                <p class="mb-1 grey--text darken-4">
                  {{ $t("m.ttlEcaDistance") }}
                </p>
                <p
                  class="mb-0 text-body-2 font-weight-bold grey--text text--darken-3"
                >
                  {{ ttlEcaDistance }}
                  <span>{{ $t("m.nm") }}</span>
                </p>
              </v-col>
              <v-col cols="4" class="transparent">
                <p class="mb-1 grey--text darken-4">
                  {{ $t("m.ttlTime") }}
                </p>
                <p
                  class="mb-0 text-body-2 font-weight-bold grey--text text--darken-3"
                >
                  {{ ttlSeaTime }}
                  <span>{{ $t("m.days") }}</span>
                </p>
              </v-col>
            </v-row>
          </v-card>
          <v-img
            v-if="advVisible"
            src="resource/adv/zsbunker-bar-en.jpg"
            @click="gotoZsBunker"
          />
          <!-- end result -->
        </v-card>
        <!-- end portPad  pad -->
      </v-card>
      <!-- end mainPadWrap -->

      <div id="settingFabPad">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn small fab dark color="cyan" v-bind="attrs" v-on="on">
              <v-icon>mdi-map-legend</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item-group v-model="baseMapSelected" color="primary">
              <v-list-item v-for="(item, index) in baseMapArr" :key="index">
                <v-list-item-avatar>
                  <v-img :src="item.url" />
                </v-list-item-avatar>
                <v-list-item-title v-html="item.title" class="text-body-2" />
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-menu>

        <v-btn class="mt-3" small fab dark color="blue" @click="changeWayPoint">
          <v-icon>mdi-router</v-icon>
        </v-btn>
        <v-btn
          class="mt-3"
          small
          fab
          dark
          color="brown darken-1"
          @click="changeTurn"
          v-if="isCompleteDistance && !routeLayerVisible"
        >
          <v-icon>mdi-navigation</v-icon>
        </v-btn>
        <v-btn class="mt-3" small fab dark color="purple" @click="clearAll">
          <v-icon>mdi-delete-sweep-outline</v-icon>
        </v-btn>
      </div>

      <map-view
        class="ma-n1"
        ref="mapCon"
        :port-point="portPoint"
        :will-del-port-point="willDelPortPoint"
        :will-reset-port-layer="willResetPortLayer"
      />

      <div id="wayPointConfigCon" class="mx-auto mt-4" v-if="routeLayerVisible">
        <v-toolbar dense light class="mb-4 grey lighten-2">
          <v-toolbar-title class="text-body-1"> Route Option </v-toolbar-title>
          <v-spacer />
          <v-btn icon @click="resetWayPointSetting">
            <v-icon class=""> mdi-backup-restore </v-icon>
          </v-btn>
          <v-btn icon @click="closeWayPointSetting">
            <v-icon class="" color="primary"> mdi-check-bold </v-icon>
          </v-btn>
        </v-toolbar>

        <v-card class="d-flex align-center justify-space-around">
          <v-checkbox
            v-model="wayPointConfigChecked"
            dense
            hide-details
            class="my-2"
            :label="$t('m.asl')"
            value="0"
          />
          <v-checkbox
            v-model="wayPointConfigChecked"
            dense
            hide-details
            class="my-2"
            :label="$t('m.antiPiracy')"
            value="1"
          />
        </v-card>
      </div>

      <div id="turningConfigCon" class="mx-auto mt-4" v-if="turnLayerVisible">
        <v-toolbar dense light class="mb-4 grey lighten-2">
          <v-toolbar-title class="text-body-1">
            {{ $t("m.turningConfig") }}
          </v-toolbar-title>
          <v-spacer />
          <v-btn icon @click="resetTurningSetting">
            <v-icon class=""> mdi-backup-restore </v-icon>
          </v-btn>
          <v-btn icon @click="closeTurningSetting">
            <v-icon class=""> mdi-close </v-icon>
          </v-btn>
        </v-toolbar>
      </div>

      <template v-if="mapCurrentPoint">
        <v-card class="pa-2 text-body-2 lonlatPad">
          <div class="mb-1">
            {{ mapCurrentPoint.lat }}
          </div>
          <div class="">
            {{ mapCurrentPoint.lon }}
          </div>
        </v-card>
        <!-- end log lat -->
      </template>
    </div>
    <!-- end mapWorkspace -->

    <LonLatMultiEnterDlg
      :visible="multiVisible"
      @cancel="closeMulti"
      @save="handleMultiSubmit"
    />

    <v-overlay :value="isCalculating">
      <v-progress-circular indeterminate size="64" />
    </v-overlay>

    <v-snackbar v-model="snackbar">
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">
          {{ $t("m.close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import _ from "lodash";
import * as esriLoader from "esri-loader";
import { mapState, mapGetters } from "vuex";
import Utils from "@/utils/index";
import httpClient from "@/api/httpClient";
import MapView from "@/components/MapView";
import Constant from "@/constant";
import MapUtil from "@/utils/mapUtil";
import LonLatMultiEnterDlg from "@/components/distance/LonLatMultiEnterDlg";

export default {
  name: "Distance",
  components: {
    MapView,
    LonLatMultiEnterDlg,
  },
  data() {
    return {
      drawer: false,

      isLoading: false,
      multiVisible: false,

      select: null,
      search: null,
      items: [],
      portPoint: null,
      speed: 12,
      willDelPortPoint: null,
      willResetPortLayer: false,

      wayPointConfigChecked: _.cloneDeep(MapUtil.WAYPOINT_CONFIG),

      snackbar: false,
      snackbarText: null,
      overlay: false,
      baseMapSelected: 0,
      baseMapArr: Constant.BASEMAPS,
    };
  },
  computed: {
    ...mapState({
      mapAndLayerLoaded: (state) => state.distance.mapAndLayerLoaded,
      portPointArr: (state) => state.distance.portPointArr,
      preservedPortPointArr: (state) => state.distance.preservedPortPointArr,
      isCompleteDistance: (state) => state.distance.isCompleteDistance,
      isCalculating: (state) => state.distance.isCalculating,
      isGettedDistanceFail: (state) => state.distance.isGettedDistanceFail,
      isNeedRefreshDistance: (state) => state.distance.isNeedRefreshDistance,
      routePorts: (state) => state.distance.routePorts,
      ttlDistance: (state) => state.distance.ttlDistance,
      ttlEcaDistance: (state) => state.distance.ttlEcaDistance,
      ttlSeaTime: (state) => state.distance.ttlSeaTime,
      mapCurrentPoint: (state) => state.distance.mapCurrentPoint,

      turnLayerVisible: (state) => state.distance.turnLayerVisible,
      originRoutes: (state) => state.distance.originRoutes,
      preservedOriginRoutes: (state) => state.distance.preservedOriginRoutes,
      preservedTtlDistance: (state) => state.distance.preservedTtlDistance,

      routeLayerVisible: (state) => state.route.routeLayerVisible,
      excWayPointArr: (state) => state.route.excWayPointArr,
      copyExcWayPointArr: (state) => state.route.copyExcWayPointArr,
      preservedExcWayPointArr: (state) => state.route.preservedExcWayPointArr,
      requiredWayPointArr: (state) => state.route.requiredWayPointArr,

      userLogoutClearFlag: (state) => state.user.userLogoutClearFlag,
      advVisible: (state) => state.distance.advVisible,
    }),

    portPadVisible() {
      return this.portPointArr.length > 0;
    },
    getBtnVisible() {
      return (
        this.portPointArr.length > 1 &&
        !this.routeLayerVisible &&
        this.portPointArr.length != this.routePorts.length
      );
    },
    clearOnlyDisBtnVisible() {
      return this.isCompleteDistance;
    },

    fabDelBtnVisible() {
      return this.portPointArr.length > 0 && !this.routeLayerVisible;
    },

    wayPointBadgeVisible() {
      return (
        this.copyExcWayPointArr.length > 0 ||
        this.requiredWayPointArr.length > 0
      );
    },

    turnBadgeVisible() {
      return (
        this.isCompleteDistance &&
        (this.preservedTtlDistance != this.ttlDistance ||
          JSON.stringify(this.originRoutes) !=
            JSON.stringify(this.preservedOriginRoutes))
      );
    },
  },

  created() {
    this.$store.commit("setRouteLayerVisible", false);
    this.$store.commit("setIsGettedDistanceFail", false);
  },
  mounted() {},

  watch: {
    isGettedDistanceFail(val) {
      if (val) {
        this.snackbarText = this.$t("m.gettedDistanceFail");
        this.snackbar = true;
      }
    },

    select(val) {
      if (!val) return;
      /* if (this.portPointArr.findIndex((elem) => elem.PortID===val.PORTID)
          !== -1 ) {
          this.snackbarText = this.$t('m.thePortExists')
          this.snackbar = true
          this.search = null
          return
        } */

      var postJson = {
        OperID: Utils.getWithExpiry("operID"),
        PortName: val.PORTNAME,
      };
      httpClient
        .post("/SPPortSuggestQry", postJson)
        .then((res) => {
          const obj = res.data.find((p) => p.PORTID === val.PORTID);
          const o = {};
          o.PortID = obj.PORTID;
          o.PortName = obj.FULLNAME.split(",")[0];
          o.FullName = obj.FULLNAME;
          o.lon = Number(obj.LONGITUDE);
          o.lat = Number(obj.LATITUDE);

          this.portPoint = o;
          this.$store.commit("addToPortPointArr", o);
          this.search = null;
        })
        .catch((err) => {});
    },
    search(val) {
      if (!val || this.isLoading) return;
      if (val.trim().length < 2) {
        return;
      }
      // if (this.items.length > 0) return
      this.isLoading = true;
      var postJson = {
        OperID: Utils.getWithExpiry("operID"),
        PortName: val,
      };
      httpClient
        .post("/PortSuggest4API", postJson)
        .then((res) => {
          this.isLoading = false;
          this.items = res.data;
        })
        .catch((err) => {
          this.isLoading = false;
        });
    },

    isCompleteDistance(val) {
      if (val === true) {
      }
    },

    speed(val) {
      if (val == "") return;
      var ttlSeaTime = 0;
      this.routePorts.forEach((ele, index) => {
        if (index > 0) {
          ele.time = _.round(ele.gVal / (val * 24), 2);
          ttlSeaTime += ele.time;
        }
      });

      this.$store.commit("setDistanceSpeed", val);
      this.$store.commit("setTtlSeaTime", _.round(ttlSeaTime, 2));
    },

    wayPointConfigChecked(val) {
      //
      this.$store.commit("setWayPointConfig", val);
      // Utils.setWithExpiry('wayPointConfigChecked', val, Constant.LOCALSTORAGE_EXPIRY_PERIOD)
    },

    baseMapSelected(val) {
      this.$store.commit("setBaseMapSelected", val);
    },

    userLogoutClearFlag(val) {
      if (val) {
        this.clearAll();
      }
    },
  },

  methods: {
    changeWayPoint() {
      if (this.turnLayerVisible) {
        return;
      }
      this.$store.commit("setRouteLayerVisible", true);
      if (this.isCompleteDistance) {
        this.$store.commit(
          "setPreservedPortPointArr",
          _.cloneDeep(this.portPointArr)
        );

        this.$store.commit(
          "setPreservedExcWayPointArr",
          _.cloneDeep(this.copyExcWayPointArr)
        );
      }
    },
    closeWayPointSetting() {
      if (this.isCompleteDistance) {
        // 重新计算
        // 主要是用来判断是否要重新计算
        if (
          JSON.stringify(this.portPointArr) !=
            JSON.stringify(this.preservedPortPointArr) ||
          JSON.stringify(this.copyExcWayPointArr) !=
            JSON.stringify(this.preservedExcWayPointArr)
        ) {
          this.getDistance();
        }
      }
      this.$store.commit("setRouteLayerVisible", false);
    },
    resetWayPointSetting() {
      // 重置路由设置
      this.$store.commit("setResetWayPointFlag", true);
      this.wayPointConfigChecked = _.cloneDeep(MapUtil.WAYPOINT_CONFIG);
    },

    changeTurn() {
      // 显示转向点
      this.$store.commit("changeTurnLayerVisible", true);
    },
    closeTurningSetting() {
      this.$store.commit("changeTurnLayerVisible", false);
    },
    resetTurningSetting() {
      // 重置转向点
      this.$store.commit("setStoreRoutes", this.preservedOriginRoutes);
      this.$store.dispatch("reBuildRoutes");
      this.$store.commit("setResetTurnLayerFlag", true);
      this.$store.commit("changeTurnLayerVisible", false);
      // this.$store.commit("setResetWayPointFlag", true)
      // this.wayPointConfigChecked = _.cloneDeep(MapUtil.WAYPOINT_CONFIG)
    },

    delPort(port, index) {
      // 移除港口
      this.willDelPortPoint = port;
      this.select = null;
      this.$store.commit("removePortPointByIndex", index);
      if (port.isWayPoint) {
        // 如果是转向点
        this.$store.commit("removeRequiredWayPoint", {
          PortID: port.PortID,
        });
      }
      if (this.isCompleteDistance && index < this.routePorts.length) {
        this.clearOnlyDis();
      }
    },

    clearOnlyDis() {
      // 清除航程
      this.$store.commit("clearDistancingResult");
      this.$store.commit("setClearOnlyDistancingFlag", true);
      // this.willResetPortLayer = true
    },

    clearAll() {
      // 清除所有
      this.select = null;
      this.$store.commit("clearAllDistance");
      this.$store.commit("setDistanceClearFlag", true);

      this.resetWayPointSetting();
      this.$store.commit("setRouteLayerVisible", false);
      this.$store.commit("changeTurnLayerVisible", false);
    },

    getDistance() {
      this.$store.commit("setIsCalculating", true);
      this.$store.dispatch("getDistance", {}).then(() => {
        // 处理设置了路由点...
        this.$store.commit("setRouteLayerVisible", false);
        this.$store.commit("setIsNeedRefreshDistance", false);
      });
    },

    openMulti() {
      this.multiVisible = true;
    },

    closeMulti() {
      this.multiVisible = false;
    },

    handleMultiSubmit(coordinate) {
      this.multiVisible = false;

      const o = {};
      o.PortID = coordinate.lon + "~" + coordinate.lat;
      o.PortName = coordinate.lonLabel + ", " + coordinate.latLabel;
      o.FullName = o.PortName;
      o.lon = _.toNumber(coordinate.lon);
      o.lat = _.toNumber(coordinate.lat);
      o.no = coordinate.no;
      o.isCoordinate = true;

      this.portPoint = o;
      this.$store.commit("addToPortPointArr", o);
    },

    gotoZsBunker() {
      console.log("gotoZsBunker");
      window.open("https://www.zsbunker.cn", "_blank");
    },
  },
};
</script>

<style scoped lang="scss">
#distanceCon {
}
#mapWorkspace {
  position: relative;
  overflow: hidden;
  height: calc(100vh - 48px);
  background: url(../assets/tile.png);
}
#mainPadWrap {
  position: absolute;
  left: 0;
  right: 0;
  z-index: 1;
  width: 380px;
  background-color: transparent;
}
#portEnterCon {
}
#portPad {
  background: rgba(179, 229, 252, 0.7) !important;
}
#settingFabPad {
  position: absolute;
  width: 48px;
  right: 16px;
  top: 30px;
  z-index: 1;
}
#wayPointConfigCon {
  position: relative;
  width: 450px;
  z-index: 1;
}
#turningConfigCon {
  position: relative;
  width: 450px;
  z-index: 1;
}
.lonlatPad {
  position: absolute;
  right: 8px;
  bottom: 8px;
  background: rgba(230, 230, 230, 0.7) !important;
}

.mybg {
  background: rgba(179, 229, 252, 0.7) !important;
}
.mybg2 {
  background: #e3f2fd !important;
}
</style>
